export const SET_USER_INFO = 'SET_USER_INFO'
export const CLEAR_USER_INFO = 'CLEAR_USER_INFO'
export const SET_STORES = 'SET_STORES'
export const SET_SIGN_IN_STATUS = 'SET_SIGN_IN_STATUS'
